import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { IRequestCallback } from '@df/api/request/request.service';
import { SessionStorageService } from '@df/browser/storage/session-storage.service';
import { getElementHeight } from '@df/dom/fn/get-element-height';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { LoginFormComponentDef } from '@df/session/login/login-form.component.def';
import { Login } from '@df/session/login/login.interfaces';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { MatchCheckDirective } from '@df/ui/form/match-check.directive';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { MuiInputDirective } from '../module/legacy/forms/mui-input.directive';
import { ActionComponent } from '../ui/api/action.component';
import { ResultComponent } from '../ui/api/result.component';
import { InputWrapBodyDirective } from '../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../ui/form/input-wrap.component';
import { RadioComponent } from '../ui/form/radio/radio.component';

declare module '@df/session/login/login.interfaces' {
    namespace Login {
        interface IRegisterFormData {
            confirmPassword?: string;
        }
    }
}

@Component({
    selector: 'login-form',
    templateUrl: './login-form.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MuiInputDirective,
        FormsModule,
        InputWrapComponent,
        ResultComponent,
        ActionComponent,
        RadioComponent,
        TranslationModule,
        InputWrapBodyDirective,
        RouterLink,
        RadioGroupDirective,
        MatchCheckDirective,
        SizeClassDirective

    ]
})
export class LoginFormComponent extends LoginFormComponentDef implements OnInit {
    /**
     * By default register form it is not visible
     */
    registerPageIsVisible: boolean = false;
    canShowLoginInfo: boolean = false;
    canShowRegisterInfo: boolean = false;
    private sessionStorageService: SessionStorageService = inject(SessionStorageService);
    scrollToService: ScrollToService = inject(ScrollToService);

    override ngOnInit() {
        if (!this.customer.model.isLoggedIn) {
            this.email = this.sessionStorageService.get('checkoutRegisterEmail');
        }
        this.sessionStorageService.remove('checkoutRegisterEmail');
        super.ngOnInit();
    }
    showRegisterForm(status: boolean): void {
        this.setRegisterPageVisibility(status);
        this.scrollToService.scrollTo(0);
        this.detectChanges();
    }
    private setRegisterPageVisibility(to: boolean): void {
        this.registerPageIsVisible = to;
        if (this.form) {
            this.form['submitAttempt'] = false;
            this.form.ngSubmit.emit();
        }
    }

    override register(onSuccess?: IRequestCallback, onError?: IRequestCallback) {
        const headerHeight = (getElementHeight('#header') || 0) + 20 || 120;
        return this.request.submitForm(
            this.form,
            this.registerStatus,
            () => this.request.nexus.customer.register(this.getRegisterData()),
            onSuccess,
            onError,
            this.getRegisterRequestOptions(),
            {
                errorScrollContainer: this.formRef?.nativeElement,
                errorScrollOptions: {
                    offset: headerHeight
                }
            }
        );
    }

    get registerData(): Partial<Login.IRegisterFormData> {
        return this.data as Partial<Login.IRegisterFormData>;
    }
    set registerData(data: Partial<Login.IRegisterFormData>) {
        this.data = data;
    }
}
